/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
import { MarkAsResolvedButtonAlertFragmentDoc } from '../MarkAsResolvedButton/markAsResolvedButton.hook'
export type DefaultActionsInProgressAlert_HubServiceNotification_Fragment = {
  __typename?: 'HubServiceNotification'
  id: string
  notificationType: Types.TaskNotificationType
}

export type DefaultActionsInProgressAlert_IvcTaskNotification_Fragment = {
  __typename?: 'IvcTaskNotification'
  id: string
  notificationType: Types.TaskNotificationType
}

export type DefaultActionsInProgressAlert_PassengerAuthentificationFallbackRequestedNotification_Fragment =
  {
    __typename?: 'PassengerAuthentificationFallbackRequestedNotification'
    id: string
    notificationType: Types.TaskNotificationType
  }

export type DefaultActionsInProgressAlert_PassengerUnbuckled_Fragment = {
  __typename?: 'PassengerUnbuckled'
  id: string
  notificationType: Types.TaskNotificationType
}

export type DefaultActionsInProgressAlert_RoadBlockageTaskNotification_Fragment =
  {
    __typename?: 'RoadBlockageTaskNotification'
    id: string
    notificationType: Types.TaskNotificationType
  }

export type DefaultActionsInProgressAlert_ShiftDeviationNotification_Fragment =
  {
    __typename?: 'ShiftDeviationNotification'
    id: string
    notificationType: Types.TaskNotificationType
  }

export type DefaultActionsInProgressAlert_StopAccessibilityDownvotedByDrivers_Fragment =
  {
    __typename?: 'StopAccessibilityDownvotedByDrivers'
    id: string
    notificationType: Types.TaskNotificationType
  }

export type DefaultActionsInProgressAlert_StopActivationFailedNotification_Fragment =
  {
    __typename?: 'StopActivationFailedNotification'
    id: string
    notificationType: Types.TaskNotificationType
  }

export type DefaultActionsInProgressAlert_StopAreaMissingActiveStopsNotification_Fragment =
  {
    __typename?: 'StopAreaMissingActiveStopsNotification'
    id: string
    notificationType: Types.TaskNotificationType
  }

export type DefaultActionsInProgressAlert_StopDownVotedByDrivers_Fragment = {
  __typename?: 'StopDownVotedByDrivers'
  id: string
  notificationType: Types.TaskNotificationType
}

export type DefaultActionsInProgressAlert_StopPotentiallyUnreachable_Fragment =
  {
    __typename?: 'StopPotentiallyUnreachable'
    id: string
    notificationType: Types.TaskNotificationType
  }

export type DefaultActionsInProgressAlert_StopValidationFailed_Fragment = {
  __typename?: 'StopValidationFailed'
  id: string
  notificationType: Types.TaskNotificationType
}

export type DefaultActionsInProgressAlert_TimeManagementNotification_Fragment =
  {
    __typename?: 'TimeManagementNotification'
    id: string
    notificationType: Types.TaskNotificationType
  }

export type DefaultActionsInProgressAlert_TripPrebookingNoAssignment_Fragment =
  {
    __typename?: 'TripPrebookingNoAssignment'
    id: string
    notificationType: Types.TaskNotificationType
  }

export type DefaultActionsInProgressAlert_VehicleAvailabilityNotification_Fragment =
  {
    __typename?: 'VehicleAvailabilityNotification'
    id: string
    notificationType: Types.TaskNotificationType
  }

export type DefaultActionsInProgressAlert_VehicleIncidentNotification_Fragment =
  {
    __typename?: 'VehicleIncidentNotification'
    id: string
    notificationType: Types.TaskNotificationType
  }

export type DefaultActionsInProgressAlert_VehicleSurveillanceNotification_Fragment =
  {
    __typename?: 'VehicleSurveillanceNotification'
    id: string
    notificationType: Types.TaskNotificationType
  }

export type DefaultActionsInProgressAlert_VehicleWaypointAttendance_Fragment = {
  __typename?: 'VehicleWaypointAttendance'
  id: string
  notificationType: Types.TaskNotificationType
}

export type DefaultActionsInProgressAlertFragment =
  | DefaultActionsInProgressAlert_HubServiceNotification_Fragment
  | DefaultActionsInProgressAlert_IvcTaskNotification_Fragment
  | DefaultActionsInProgressAlert_PassengerAuthentificationFallbackRequestedNotification_Fragment
  | DefaultActionsInProgressAlert_PassengerUnbuckled_Fragment
  | DefaultActionsInProgressAlert_RoadBlockageTaskNotification_Fragment
  | DefaultActionsInProgressAlert_ShiftDeviationNotification_Fragment
  | DefaultActionsInProgressAlert_StopAccessibilityDownvotedByDrivers_Fragment
  | DefaultActionsInProgressAlert_StopActivationFailedNotification_Fragment
  | DefaultActionsInProgressAlert_StopAreaMissingActiveStopsNotification_Fragment
  | DefaultActionsInProgressAlert_StopDownVotedByDrivers_Fragment
  | DefaultActionsInProgressAlert_StopPotentiallyUnreachable_Fragment
  | DefaultActionsInProgressAlert_StopValidationFailed_Fragment
  | DefaultActionsInProgressAlert_TimeManagementNotification_Fragment
  | DefaultActionsInProgressAlert_TripPrebookingNoAssignment_Fragment
  | DefaultActionsInProgressAlert_VehicleAvailabilityNotification_Fragment
  | DefaultActionsInProgressAlert_VehicleIncidentNotification_Fragment
  | DefaultActionsInProgressAlert_VehicleSurveillanceNotification_Fragment
  | DefaultActionsInProgressAlert_VehicleWaypointAttendance_Fragment

export const DefaultActionsInProgressAlertFragmentDoc = gql`
    fragment DefaultActionsInProgressAlert on TaskNotification {
  ...MarkAsResolvedButtonAlert
}
    ${MarkAsResolvedButtonAlertFragmentDoc}`
